export default __webpack_public_path__ + "static/media/blog-post-layout-03-img-06.2298b318.jpg";